/**
 * User: herbert
 * Date: 10.05.16
 * Time: 13:48
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */


import React from 'react';

import steleActions from '../../actions/stele-actions.js';

import * as config from '../../../../config.js';

export default React.createClass({
	propTypes: {
		wide: React.PropTypes.bool.isRequired,
		horiz: React.PropTypes.string.isRequired,
		vert:  React.PropTypes.string.isRequired,
		k3000: React.PropTypes.bool.isRequired,
		parentIdx: React.PropTypes.number.isRequired,
		childIdx: React.PropTypes.number.isRequired
	},
	_onMediumClick: function () {
		if(this.props.wide)
			steleActions.setType(config.F_25, this.props.parentIdx, this.props.childIdx, true);
	},
	_onWideClick: function () {
		if(!this.props.wide)
			steleActions.setType(config.F_45, this.props.parentIdx, this.props.childIdx, true);
	},

	_onLeftClick: function () {
		if(this.props.horiz !== config.F_H_LEFT)
			steleActions.setDirection(config.F_H_LEFT, this.props.parentIdx, this.props.childIdx, true);
	},
	_onRightClick: function () {
		if(this.props.horiz !== config.F_H_RIGHT)
			steleActions.setDirection(config.F_H_RIGHT, this.props.parentIdx, this.props.childIdx, true);
	},
	_onSymClick: function () {
		if(this.props.horiz !== config.F_H_SYM)
			steleActions.setDirection(config.F_H_SYM, this.props.parentIdx, this.props.childIdx, true);
	},

	_onParClick: function () {
		if(this.props.vert !== config.F_V_PAR)
			steleActions.setDirection(config.F_V_PAR, this.props.parentIdx, this.props.childIdx, false);
	},
	_onSoftClick: function () {
		if(this.props.vert !== config.F_V_SOFT)
			steleActions.setDirection(config.F_V_SOFT, this.props.parentIdx, this.props.childIdx, false);
	},
	_onStrongClick: function () {
		if(this.props.vert !== config.F_V_STRONG)
			steleActions.setDirection(config.F_V_STRONG, this.props.parentIdx, this.props.childIdx, false);
	},
	_onNearClick: function () {
		if(this.props.vert !== config.F_V_NEAR_DOWN)
			steleActions.setDirection(config.F_V_NEAR_DOWN, this.props.parentIdx, this.props.childIdx, false);
	},
	_onDownClick: function () {
		if(this.props.vert !== config.F_V_DOWN)
			steleActions.setDirection(config.F_V_DOWN, this.props.parentIdx, this.props.childIdx, false);
	},
	_onK3000Click: function () {
		if(!this.props.k3000) {
			steleActions.setK3000(true, this.props.parentIdx, this.props.childIdx);
		}
	},
	_onK4000Click: function () {
		if(this.props.k3000) {
			steleActions.setK3000(false, this.props.parentIdx, this.props.childIdx);
		}
	},
	render: function () {
		return (
				<div className="slx-stele-summary__twinspot" >
					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.wide ? 'slx-stele-summary__option' : 'slx-stele-summary__selected'} onClick={this._onMediumClick} >
							<img src="img/stele/parameters/Icon_rund_black_5.png" className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.wide ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onWideClick} >
							<img src="img/stele/parameters/Icon_rund_black_6.png"  className="slx-stele-summary__option-img48" />
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.vert === config.F_V_PAR ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onParClick} >
							<img src="img/stele/parameters/Icon_vert_par.svg"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.vert === config.F_V_SOFT ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onSoftClick} >
							<img src="img/stele/parameters/Icon_vert_soft.svg"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.vert === config.F_V_STRONG ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onStrongClick} >
							<img src="img/stele/parameters/Icon_vert_strong.svg"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.vert === config.F_V_NEAR_DOWN ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onNearClick} >
							<img src="img/stele/parameters/Icon_vert_down_near.svg"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.vert === config.F_V_DOWN ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onDownClick} >
							<img src="img/stele/parameters/Icon_vert_down.svg"  className="slx-stele-summary__option-img48" />
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.horiz === config.F_H_LEFT ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onLeftClick} >
							<img src="img/stele/parameters/Icon_rund_black_1.png"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.horiz === config.F_H_RIGHT ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onRightClick} >
							<img src="img/stele/parameters/Icon_rund_black_2.png"  className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.horiz === config.F_H_SYM ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onSymClick} >
							<img src="img/stele/parameters/Icon_rund_black_3.png"  className="slx-stele-summary__option-img48" />
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.k3000 ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onK3000Click} >
							<span className="slx-stele-summary__option-text">3000&nbsp;K</span>
						</div>
						<div className={this.props.k3000 ? 'slx-stele-summary__option' : 'slx-stele-summary__selected'} onClick={this._onK4000Click} >
							<span className="slx-stele-summary__option-text">4000&nbsp;K</span>
						</div>
					</div>
				</div>
		);
	}
});
